import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import "moment/locale/id";
import domain from "../util/domain";
import Alert from "../util/alert";
import Loading from "../common/loading.component";
import DiagnosticResultPdf from "./pdf/diagnostic.component";
import { QRCode } from "react-qrcode-logo";

//import WaitingButton from "../common/waitingbutton.component";
//import DatePicker, { registerLocale } from "react-datepicker";
//import id from "date-fns/locale/id";
//import Loading from "../common/loading.component";
//registerLocale("id", id);

export default function Diagnostic() {
    let { mrn, id } = useParams();

    const [patient, setPatient] = useState();
    const [diagnostic, setDiagnostic] = useState();
    const [notification, setNotification] = useState();
    const [qrCodeDataUri, setQRCodeDataUri] = useState();

    useEffect(() => {
        async function fetchData() {
            await axios
                .get(`${domain}/patients/` + mrn + "/" + id + "/diagnostic")
                .then((response) => {
                    setPatient(response.data.patient);
                    setDiagnostic(response.data.diagnostic);
                })
                .catch((error) => {
                    if (!error.response) {
                        // network error
                        setNotification({
                            message: "Exception: " + error,
                            type: "danger"
                        });
                    } else {
                        //setError(error.response.data.msg);
                        setNotification({
                            message: error.response.data.msg,
                            type: "danger"
                        });
                    }
                });
        }
        fetchData();
    }, [mrn, id]);

    useEffect(() => {
        if (diagnostic) {
            var delayInMilliseconds = 500; //1 second
            setTimeout(function () {
                //your code to be executed after 1 second
                setQRCodeDataUri(document.querySelector("canvas").toDataURL("image/jpg", 0.3));
            }, delayInMilliseconds);
        }
    }, [diagnostic]);

    return (
        <div className="mt-3">
            {notification ? (
                <Alert message={notification.message} type={notification.type} />
            ) : patient && diagnostic ? (
                <div>
                    <h5 className="text-center">Data Pemeriksaan Diagnostik</h5>
                    <table className="table table-sm">
                        <tbody>
                            <tr>
                                <th>MRN</th>
                                <td>{patient.mrn}</td>
                            </tr>
                            <tr>
                                <th>Nama</th>
                                <td>{patient.fullName}</td>
                            </tr>
                            <tr>
                                <th>Tgl. Pemeriksaan</th>
                                <td>{moment(diagnostic.completedAt).format("dddd, DD-MM-YYYY")}</td>
                            </tr>
                            <tr>
                                <th>Dokter</th>
                                <td>{diagnostic.doctor ? diagnostic.doctor : diagnostic.requestedBy}</td>
                            </tr>
                            <tr>
                                <th>Jenis Pemeriksaan</th>
                                <td>
                                    {diagnostic.category} - {diagnostic.name}
                                </td>
                            </tr>
                            <tr style={{ visibility: "hidden", display: "none" }}>
                                <td colSpan={2}>
                                    <div id="canvas">
                                        <QRCode
                                            value={"https://archive.rscitrasundari.com/diagnostic/" + patient.mrn + "/" + diagnostic._id}
                                            size={95}
                                            qrStyle="dots"
                                            removeQrCodeBehindLogo={true}
                                            logoImage="/img/Logo.png"
                                            logoWidth={20}
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                {qrCodeDataUri && (
                                    <td colSpan={2} className="text-center">
                                        <DiagnosticResultPdf patient={patient} resultData={diagnostic} qrImage={qrCodeDataUri} />
                                    </td>
                                )}
                            </tr>
                            {diagnostic.attachmentUrls &&
                                diagnostic.attachmentUrls.map((attachment, index) => (
                                    <tr>
                                        <td colSpan={2} className="text-center">
                                            <a target="_blank" rel="noreferrer" href={attachment} className="btn btn-sm btn-outline-secondary">
                                                Download Foto {index > 0 ? "ke-" + parseInt(index + 1) : ""}
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            <tr className="table-primary text-center">
                                <th colSpan={2}>Terverifikasi</th>
                            </tr>
                            <tr>
                                <td colSpan={2}>
                                    Jika download tidak berhasil, mohon untuk:
                                    <ul>
                                        <li>Tekan tombol menu (...) di pojok kanan atas dan buka di browser, atau</li>
                                        <li>Copy link/URL dan buka di browser Anda (Safari/Google Chrome)</li>
                                    </ul>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ) : (
                <Loading />
            )}
        </div>
    );
}
